(() => {
  document.documentElement.classList.add('earthycove-core-ready');

  const assetUrl = (filename) => {
    const script = document.currentScript || Array.from(document.scripts).find((item) => item.src.includes('earthycove-core.js'));
    if (!script || !script.src) return '';

    return script.src.replace(/earthycove-core\.js(?:\?.*)?$/, filename);
  };

  const hydrateBrandAssets = () => {
    const logo = assetUrl('earthycove-logo.svg');
    const favicon = assetUrl('earthycove-favicon.svg');

    if (favicon && !document.querySelector('link[href*="earthycove-favicon.svg"]')) {
      const icon = document.createElement('link');
      icon.rel = 'icon';
      icon.type = 'image/svg+xml';
      icon.href = favicon;
      document.head.appendChild(icon);
    }

    const logoLink = document.querySelector('.header__logo a');
    if (!logoLink || logoLink.querySelector('img') || !logo) return;

    logoLink.classList.remove('header__logo--text');
    logoLink.classList.add('header__logo--image', 'header__logo--earthycove');
    logoLink.textContent = '';

    const mobile = document.createElement('img');
    mobile.src = logo;
    mobile.loading = 'eager';
    mobile.width = 560;
    mobile.height = 132;
    mobile.alt = 'Earthy Cove';
    mobile.className = 'logo header__logo--mobile md:hidden';

    const desktop = document.createElement('img');
    desktop.src = logo;
    desktop.loading = 'eager';
    desktop.width = 560;
    desktop.height = 132;
    desktop.alt = 'Earthy Cove';
    desktop.className = 'logo header__logo--desktop md:block hidden';

    logoLink.append(mobile, desktop);
  };

  const normalizeLogoHeading = () => {
    document.querySelectorAll('h1.header__logo').forEach((heading) => {
      const wrapper = document.createElement('div');
      Array.from(heading.attributes).forEach((attribute) => {
        wrapper.setAttribute(attribute.name, attribute.value);
      });
      wrapper.append(...Array.from(heading.childNodes));
      heading.replaceWith(wrapper);
    });
  };

  const normalizeHeaderAndFooterMenus = () => {
    document.querySelectorAll('.topbar__left, .topbar__right').forEach((column) => {
      column.remove();
    });

    document.querySelectorAll('.topbar__center .topbar__text p').forEach((item) => {
      item.textContent = 'Curated home goods. Secure checkout. Worldwide shipping.';
    });

    const footer = document.querySelector('.footer');
    if (!footer) return;

    footer.querySelectorAll('.footer-block--menu').forEach((block, index, blocks) => {
      const signature = Array.from(block.querySelectorAll('a'))
        .map((link) => `${link.textContent.trim()}|${link.getAttribute('href')}`)
        .join('::');
      const duplicate = Array.from(blocks).slice(0, index).some((previous) =>
        Array.from(previous.querySelectorAll('a'))
          .map((link) => `${link.textContent.trim()}|${link.getAttribute('href')}`)
          .join('::') === signature
      );

      if (signature && duplicate) block.remove();
    });
  };

  const bindMenuDrawerFocus = () => {
    const menuDrawer = document.getElementById('MenuDrawer');
    if (!menuDrawer || menuDrawer.dataset.ecFocusBound === 'true') return;

    menuDrawer.dataset.ecFocusBound = 'true';

    const firstVisibleFocusable = () => {
      const candidates = menuDrawer.querySelectorAll(
        '.menu-drawer__item-link, summary, button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );

      return Array.from(candidates).find((element) => {
        const box = element.getBoundingClientRect();
        const styles = window.getComputedStyle(element);
        return box.width > 0 && box.height > 0 && styles.visibility !== 'hidden' && styles.display !== 'none';
      });
    };

    const focusMenuStart = () => {
      if (menuDrawer.hidden || !menuDrawer.hasAttribute('open')) return;

      const focusable = firstVisibleFocusable();
      if (focusable && !menuDrawer.contains(document.activeElement)) {
        focusable.focus({ preventScroll: true });
      }
    };

    document.addEventListener('menu-drawer:open', () => {
      window.setTimeout(focusMenuStart, 140);
      window.setTimeout(focusMenuStart, 360);
    });
  };

  const init = () => {
    normalizeLogoHeading();
    hydrateBrandAssets();
    normalizeHeaderAndFooterMenus();
    bindMenuDrawerFocus();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
